import { RefObject } from 'react';

import { usePanelResize } from './usePanelResize';

export type PanelHeightResizeHandleEdge = 'top' | 'bottom';

export interface UsePanelHeightResizeOptions {
  /** Which edge of the panel carries the drag handle. */
  handleEdge: PanelHeightResizeHandleEdge;
  initialPanelHeightPct?: number;
  minPanelHeightPx?: number;
}

/**
 * Vertical panel height as % of host (`offsetParent` or create-audience modal row),
 * driven by a horizontal resize handle on the top or bottom edge of the panel.
 */
export function usePanelHeightResize(
  expanded: boolean,
  panelRef: RefObject<HTMLDivElement | null>,
  {
    handleEdge,
    initialPanelHeightPct = 100,
    minPanelHeightPx,
  }: UsePanelHeightResizeOptions
) {
  const { panelSizePct, setPanelSizePct, handleResizePointerDown } =
    usePanelResize(expanded, panelRef, {
      axis: 'vertical',
      handleEdge,
      initialSizePct: initialPanelHeightPct,
      minSizePx: minPanelHeightPx,
    });

  return {
    panelHeightPct: panelSizePct,
    setPanelHeightPct: setPanelSizePct,
    handleResizePointerDown,
  };
}
